import { cn as e } from "../../lib/utils.es.js";
import "react";
import * as t from "@radix-ui/react-accordion";
import { ChevronDownIcon as n } from "lucide-react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
// libs/ui-lib/src/components/ui/accordion.tsx
function a({ ...e }) {
	return /* @__PURE__ */ r(t.Root, {
		"data-slot": "accordion",
		...e
	});
}
function o({ className: n, ...i }) {
	return /* @__PURE__ */ r(t.Item, {
		"data-slot": "accordion-item",
		className: e("border-b last:border-b-0", n),
		...i
	});
}
function s({ className: a, chevronClassName: o, children: s, ...c }) {
	return /* @__PURE__ */ r(t.Header, {
		className: "flex",
		children: /* @__PURE__ */ i(t.Trigger, {
			"data-slot": "accordion-trigger",
			className: e("flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left font-medium text-sm outline-none transition-all hover:underline focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180", a),
			...c,
			children: [s, /* @__PURE__ */ r(n, { className: e("pointer-events-none size-4 shrink-0 translate-y-0.5 text-muted-foreground transition-transform duration-200", o) })]
		})
	});
}
function c({ className: n, children: i, ...a }) {
	return /* @__PURE__ */ r(t.Content, {
		"data-slot": "accordion-content",
		className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
		...a,
		children: /* @__PURE__ */ r("div", {
			className: e("pt-0 pb-4", n),
			children: i
		})
	});
}
export { a as Accordion, c as AccordionContent, o as AccordionItem, s as AccordionTrigger };
